import React from "react";
import "./LoadingComponent.css";

const Loading = () => {
  return (
    <div>
      <div className="loading-spinner"></div>Loading components, please wait...
    </div>
  );
};

export default Loading;
